<template>
	<div :class="`bg-background h-${this.heightSize} flex gap-${gapSize}`">
		<span
			v-for="(status, i) in cardStatuses"
			:key="status.propKey"
			:class="[
				`flex-1 h-${heightSize}`,
				{ 'bg-success': i <= statusIndex },
				{ 'bg-primary': orderStatus === statuses.rejected },
			]"
		/>
	</div>
</template>

<script>
	import { cardStatuses } from '@/constants/kanban';
	import { statuses } from '@/constants/mapOrderStatuses';

	export default {
		name: 'OrderStatusProgressBar',
		props: {
			orderStatus: {
				type: String,
				required: true,
			},
			heightSize: {
				type: String,
				default: '1',
			},
			gapSize: {
				type: String,
				default: 'px',
			},
		},
		data: () => ({
			cardStatuses,
			statuses,
		}),
		computed: {
			statusIndex() {
				return this.cardStatuses.findIndex((status) => status.propValue === this.orderStatus);
			},
		},
	};
</script>

<style scoped></style>
